module.exports = __webpack_public_path__ + "img/ark.3f7b41ef.png";